import validate from '@ott/utility-form-validate';
import * as validationRules from './validationRules';

const SPACE = /\s/g;
const {
  isRequired,
  isCreditCard,
  isValidExpDateMM,
  isValidExpDateYY,
  isValidCardHolder,
  isValidCVV,
} = validationRules;

const partnersValidations = {
  aktivno: {
    msg: 'Оплата возможна только с пенсионной карты',
    validate: (value, fields, props) => {
      const activeCard = props.paymentCardInfo.activeCard;
      const cardBin =
        (activeCard && activeCard.bin) || Number(value.replace(SPACE, '').substr(0, 6));

      return cardBin === 536961 || cardBin === 639002;
    },
  },
};

const getRulesForValues = ({ syncCardValidation }) => ({
  cardNumber: syncCardValidation ? [isRequired, isCreditCard] : [isRequired],
  expMonth: [isRequired, isValidExpDateMM],
  expYear: [isRequired, isValidExpDateYY],
  cardHolder: [isValidCardHolder],
  cardCVV: [isRequired, isValidCVV],
});

export default function validateCard(values, props) {
  const {
    partner: { data: partnerData } = {},
    isCardHolderRequired = false,
    excludeCardCountryCodes = [],
  } = props;

  if (values.id) {
    return validate({
      cardCVV: [isRequired, isValidCVV],
    })(values, props);
  }

  const rulesForValues = getRulesForValues({
    syncCardValidation: !excludeCardCountryCodes.length,
  });

  if (partnerData && partnerData.source === 'aktivno') {
    rulesForValues.cardNumber = [...rulesForValues.cardNumber, partnersValidations.aktivno];
  }

  if (isCardHolderRequired) {
    rulesForValues.cardHolder = [...rulesForValues.cardHolder, isRequired];
  }

  return { ...validate(rulesForValues)(values, props) };
}
